var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLimitedTime = function SvgLimitedTime(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 80 80"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2940"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2854"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2823"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ffcf33",
    d: "M43.403 75.494a5.517 5.517 0 0 1 0-11.034A24.253 24.253 0 1 0 19.15 40.207a5.517 5.517 0 1 1-11.034 0 35.289 35.289 0 1 1 35.287 35.288Z",
    "data-name": "Path 6072"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffcf33",
    d: "M12.585 48.077 1.593 37.087a1.483 1.483 0 0 1 1.05-2.534h21.984a1.485 1.485 0 0 1 1.048 2.534l-10.99 10.99a1.476 1.476 0 0 1-2.1 0",
    "data-name": "Path 6073"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#495867",
    d: "M43.405 46.463a3.68 3.68 0 0 1-3.678-3.675V25.641a3.678 3.678 0 1 1 7.356 0v17.147a3.68 3.68 0 0 1-3.678 3.675",
    "data-name": "Line 200"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#495867",
    d: "M50.526 53.592a3.67 3.67 0 0 1-2.6-1.081l-7.123-7.121a3.678 3.678 0 0 1 5.2-5.2l7.123 7.121a3.678 3.678 0 0 1-2.6 6.279Z",
    "data-name": "Line 201"
  }))))));
};
export default SvgLimitedTime;